import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultEmployee = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.ANGESTELLTER }>;
} => ({
    beschaeftigung: {
        angestellter: {
            beschaeftigungsverhaeltnis: {
                arbeitgeber: {
                    anschrift: {
                        hausnummer: null,
                        land: null,
                        ort: null,
                        plz: null,
                        strasse: null,
                    },
                    branche: null,
                    name: null,
                },
                befristetBis: null,
                befristung: null,
                berufsbezeichnung: null,
                beschaeftigtSeit: null,
                inProbezeit: null,
                inProbezeitBis: null,
                kumulierterJahreswert: null,
                nettoeinkommenMonatlich: null,
                nettoeinkommenVorletzterMonat: null,
                nettoeinkommenVorVorletzterMonat: null,
            },
        },
        beschaeftigungsart: EMPLOYMENT_TYPES.ANGESTELLTER,
        steuerklasse: null,
    },
});
export default getDefaultEmployee;
